import React from "react";
import { AttachmentIcon } from "../Icons";
import { sizeConverter } from "../../helpers/sizeConverter";
import styles from "./FileAnchor.module.scss";

interface Props {
  name: string;
  size: number;
  description?: string;
  path: string;
}

const FileAnchor = (props: Props) => {
  const { path, name, size, description } = props;

  return (
    <div className={styles.fileAnchorWrapper}>
      <div className={styles.fileAnchorLine}>
        <a href={path} download={name} target="blank">
          <AttachmentIcon fillColor={null} />
          <span>{name}</span>
        </a>
        <span className={styles.fileAnchorSize}>{sizeConverter(size)}</span>
      </div>
      {description && (
        <span className={styles.fileAnchorDescription}>{description}</span>
      )}
    </div>
  );
};

export default FileAnchor;
